import { render } from "./DataHeader.vue?vue&type=template&id=471d8437"
import script from "./DataHeader.vue?vue&type=script&lang=js"
export * from "./DataHeader.vue?vue&type=script&lang=js"

import "./DataHeader.vue?vue&type=style&index=0&id=471d8437&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__